import React from 'react';
import { Box, Typography } from '@material-ui/core';
import theme from 'theme';
import UserInfo from './UserInfo';
import { COLOR_DISCLAIMER_GREY, COLOR_GREY_LIGHT } from '../../../constants';

const YourTeam = ({ buyerAgent, loanOfficer, onContactAgentClick, mls_source_code, relocateListingAgentInfo }) => {

    const disclaimerAsterisk = relocateListingAgentInfo ? '*' : null;
    return (
        <>
            <Box mb={2}>
                <Typography variant="h5">Your agent</Typography>
            </Box>
            <Box>
                <UserInfo
                    user={buyerAgent}
                    showContactAgentButton={!!onContactAgentClick}
                    onContactAgentClick={onContactAgentClick}
                />
            </Box>

            {loanOfficer && loanOfficer.vendor?.company_type === 'Mortgage' && (
                <>
                    <Box mt={4} pl={4} py={3} pr={6} bgcolor={COLOR_GREY_LIGHT} borderRadius="4px" fontSize={16}>
                        {buyerAgent.first_name} works closely with {loanOfficer.name}{disclaimerAsterisk} who can help you get
                        pre-qualified, lock in an interest rate, and answer any financing questions you might have.

                        {relocateListingAgentInfo ? (
                            <Typography
                                component="p"
                                variant="caption"
                                style={{
                                    marginTop: theme.spacing(1),
                                    color: COLOR_DISCLAIMER_GREY,
                                }}
                            >
                                *Lending partner supplied by site owner and not affiliated with {mls_source_code} data.
                            </Typography>
                        ) : null}

                    </Box>
                    <Box mt={40 / 8}>
                        <UserInfo user={loanOfficer} />
                    </Box>{' '}
                </>
            )}
        </>
    );
};

export default YourTeam;
